/**
 * Single source of truth for the free documents limit.
 */
export const MAX_FREE_DOCUMENTS = 1

/**
 * Saldo Apps Inc. legal address
 */
export const LEGAL_ADDRESS =
  'Saldo Apps Inc. USA, 19709, State of Delaware, New Castle, Middletown, 651 N Broad St Suite 201'
